import authService from './auth-service/authService';
import fakeCustomerService from './fake-customer-service/fakeCustomerService';
import ProductService from './product-service/ProductService';
import InventaireService from './inventaire-service/InventaireService';
import InventoryService from './inventory-service/InventoryService';
import ShopAuthService from './shop-auth-service/shopAuthService';

export default {
  authService,
  fakeCustomerService,
  ProductService,
  InventoryService,
  InventaireService,
  ShopAuthService,
};
